module.exports = __webpack_public_path__ + "static/media/check.b3611b9a.png";